import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Images
import salesBanner from '../../assets/img/partnerPortal/sales/Half Wave.svg';
import email from '../../assets/img/general/email.svg';

// Scss
import '../../assets/css/partnerProgram.scss';
import '../../assets/css/partnerPortal/welcome.scss';



import Title from "../../components/Title";
import CardsFormatThree from "../../components/CardsFormatThree";
import Card from "../../models/common/Card";
import iconThird from '../../assets/img/partnerPortal/homepage/vector_3.png';

function PortalSupport() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  const TITLE = "Partner Portal Support";
  const SUB_TITLE = "Here are some videos and pages to assist you in navigating the partner portal. Should you have questions, feel free to reach out to partner operations for assistance.";
  const BUTTON_NAME = "Contact Partner Operations";
  const BUTTON_LINK= "mailto:partneroperations@dynatrace.com";

  const card1: Card = new Card("How to navigate the portal", "Learn more", iconThird, undefined, "https://partners.dynatrace.com/#/collateral/programs/8a9997208ce5be8e018cf3e9cbc91bcd");
  const card2: Card = new Card("How to launch a Marketing campaign", "Learn more", iconThird, undefined, "https://partners.dynatrace.com/#/collateral/programs/8a9983d989d674ac0189d9db7e511df6");
  const card3: Card = new Card("How to receive training", "Learn more", iconThird, undefined, "https://partners.dynatrace.com/#/page/enablement");
  const cardsFirstRow: Card[] = [card1, card2, card3];
  const ALL_CARD_ROWS: Record<number, Card[]> = {
    [0]: cardsFirstRow
  }

  return (
    <>
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center mb-3 w-100">
                <img src={salesBanner} className=' shadow-4 imageBannerSales' alt='...' />
                <div className="d-flex row w-100 marginsAssociate">
                    <div className="d-flex pt-4 flex-column align-items-start justify-content-center width42 mr-5">
                        <div className="d-flex align-items-start pb-4">
                            <Title classNameText="salesTitle" title={TITLE} withoutLine={true}/>
                        </div>
                        <div className="d-flex align-items-start">
                            <div className="subCopyLetters mb-3">
                                {SUB_TITLE}
                            </div>
                        </div>
                        <div className="d-flex flex-column align-items-center align-self-stretch mt-3">
                            <div className="d-flex flex-column align-items-start justify-content-center w-100">
                                <a href={BUTTON_LINK} target="_parent" className="w-100"  >
                                    <div className="d-flex align-items-start justify-content-center">
                                        <img src={email}  alt='...' width={"3%"}  />
                                        <div className="d-flex flex-column align-items-start w-100 ChangeLineColor">
                                            <div className="d-flex align-items-start buttonMail">{BUTTON_NAME}</div>
                                            <div className="lineBlack3 width29"></div>

                                        </div>
                                    </div>
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <CardsFormatThree cards={ALL_CARD_ROWS} />
        </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default PortalSupport;

